<template>
    <div class="company-show-main-div">
        <div class="text-2xl text-grey-darkest mb-4">{{ company.name }}</div>
        <div class="flex items-center justify-between mb-8">
            <div class="sm:flex sm:flex-row flex flex-col mb-4 sm:mb-0">
                <a v-if="canEdit && !sharedCompanyObj.isSharedCompany" href="/company/create"
                   class="border-4 border-followup-nav py-2 px-3 bg-followup-nav hover:bg-followup-nav-darker text-white rounded-full mr-2 mb-2 sm:mb-0 hover:no-underline">
                    New Company
                </a>
                <a href="/company"
                   class="border-4 border-followup-nav py-2 px-3 bg-followup-nav hover:bg-followup-nav-darker text-white rounded-full hover:no-underline">
                    View All
                </a>
            </div>
            <div class="sm:flex sm:flex-row flex flex-col mb-4 sm:mb-0">
                <div class="dropdown float-left" v-if="quickBookAccess && company.is_residential == 0">
                    <button type="button"
                            class="py-2 px-3 standard-dropdown border-1 border-teal hover:bg-followup-nav  rounded-full hover:text-white mx-1 text-teal text-followup-nav focus:outline-none"
                            id="quickBookDropDown" data-toggle="dropdown"
                            aria-haspopup="true" aria-expanded="false">
                        <i v-if="connectingQuickBook" class="fa fa-spin fa-spinner text-grey-darkest" aria-hidden="true"></i>
                        QB Actions <i class="fa fa-caret-down mx-1"></i>
                    </button>
                    <div class="standard-dropdown dropdown-menu dropdown-menu-right" aria-labelledby="quickBookDropDown">
                        <button type="button" class="dropdown-item py-2" @click="fetchInvoices()" v-if="!isQuickBookConnected">
                            Connect
                        </button>
                        <button type="button" class="dropdown-item py-2" @click="disconnectQuickBook()" v-else>
                            Disconnect
                        </button>
                        <button type="button" class="dropdown-item py-2" @click="syncInvoices()" v-if="isQuickBookConnected">
                            Sync QuickBooks
                        </button>
                        <button type="button" class="dropdown-item py-2" @click="goToCustomerOnQB()" v-if="isQuickBookConnected">
                            Go To Customer <i class="fa fa-external-link-square" aria-hidden="true"></i>
                        </button>
                    </div>
                </div>

                <company-vista ref="CompanyVistaComponent" :company="company" :contacts="contacts" v-if="vistaAccess && company.is_residential === 0" :erpConnections="erpConnections" :companyContactVistaHistory="companyContactVistaHistory" :can-erp-create="canErpCreate" :can-erp-update="canErpUpdate" :can-erp-sync="canErpSync"></company-vista>
                <foundation-company ref="FoundationCompany" :company="company" :contacts="contacts" :foundationCompanyMapping="foundationCompanyMapping" v-if="foundationAccess && foundationCompanyMapping && company.is_residential == 0"  :foundationCustomerNoCustomFieldId="foundationCustomerNoCustomFieldId" :can-erp-create="canErpCreate" :can-erp-update="canErpUpdate" :can-erp-sync="canErpSync"></foundation-company>
                <sage-100-company ref="Sage100Company" :contacts="contacts" v-if="sageAccess && sageCompanyMapping && company.is_residential == 0" :sageCompanyMapping="sageCompanyMapping" :company="company" :team="team" :user="user" :can-erp-create="canErpCreate" :can-erp-update="canErpUpdate" :can-erp-sync="canErpSync"></sage-100-company>
                <company-spectrum ref="CompanySpectrumComponent" :company="company" :contacts="contacts" :spectrumCompanyMapping="spectrumCompanyMapping" v-if="spectrumAccess && spectrumCompanyMapping && company.is_residential == 0" :spectrumCustomerCodeCustomFieldId="spectrumCustomerCodeCustomFieldId" :can-erp-create="canErpCreate" :can-erp-update="canErpUpdate" :can-erp-sync="canErpSync"></company-spectrum>
                <sage-300-company :custom-customer-code-field-id="getSafe(() => agaveErp.company_field.custom_customer_field.follow_up_field)" :custom-contact-code-field-id="getSafe(() => agaveErp.company_field.custom_contact_field.follow_up_field)" :custom-contact-code-field-name="getSafe(() => agaveErp.company_field.custom_contact_field.follow_up_field_label)" ref="Sage300Company" :contacts="contacts" v-if="agaveErp && agaveErp.third_party_name == 'sage-300-cre' && agaveErp.company_field && company.is_residential == 0" :mapping="agaveErp.company_field" :company="company" :team="team" :user="user" :can-erp-create="canErpCreate" :can-erp-update="canErpUpdate" :can-erp-sync="canErpSync"></sage-300-company>


                <button @click="syncFromFoundationValidation" v-if="foundationPullDataAccess"
                        class="py-2 px-3 border-1 border-followup-nav hover:bg-followup-nav hover:text-white text-followup-nav rounded-full focus:outline-none">
                    <i v-if="syncFromFoundationLoading" class="fa fa-spin fa-spinner text-grey-darkest" aria-hidden="true"></i> Sync From Foundation
                </button>
                <button @click="print"
                        class="py-2 px-3 border-1 border-followup-nav hover:bg-followup-nav hover:text-white text-followup-nav rounded-full focus:outline-none">
                    Print
                </button>
                <button v-if="canEdit && (!sharedCompanyObj.isSharedCompany)" @click.prevent="showMergeCompanyForm = true"
                        class="py-2 px-3 border-1 border-followup-nav hover:bg-followup-nav hover:text-white text-followup-nav rounded-full focus:outline-none">
                    Merge
                </button>
                <button v-if="(team.has_share_company_access && canEdit && !sharedCompanyObj.isSharedCompany)" @click="shareModal"
                        class="hover:no-underline py-2 px-3 border-1 border-followup-nav hover:bg-followup-nav text-followup-nav hover:text-white rounded-full focus:outline-none">
                    Share
                </button>
                <button v-if="canDelete && !sharedCompanyObj.isSharedCompany" @click="destroy"
                        class="py-2 px-3 border-1 border-followup-nav hover:bg-followup-nav hover:text-white text-followup-nav rounded-full focus:outline-none">
                    Delete
                </button>
                <a v-if="canEdit && !sharedCompanyObj.isSharedCompany" :href="`/company/${company.id}/resource-files`"
                   class="hover:no-underline py-2 px-3 border-1 border-followup-nav hover:bg-followup-nav text-followup-nav hover:text-white rounded-full mr-2 focus:outline-none">
                    Documents
                </a>
                <button v-if="canEdit && (!sharedCompanyObj.isSharedCompany || (sharedCompanyObj.access !== null && sharedCompanyObj.access !== 'view'))" @click="submitForm"
                        class="py-2 px-3 border-1 border-followup-nav hover:bg-followup-nav hover:text-white text-followup-nav rounded-full focus:outline-none">
                    Save
                </button>
            </div>
        </div>

        <div class="">
            <div class="row w-100 no-gutters" style="align-items: flex-start;">
                <div class="col-md-3">
                    <div class="mr-3 rounded shadow-md bg-white">
                        <form @keydown="form.errors.clear($event.target.name)">
                            <div class="border-b-2 border-followup-nav text-grey-darkest rounded-t p-2">
                                <span class="pl-2">Company Information</span><span class="float-right"><img v-if="company.quick_book_connected && team.is_quick_book_connected && company.is_residential == 0" class="qb-small-logo" src="https://prod-followupcrm.s3.us-east-2.amazonaws.com/qb-logo-small.png"></span>
                            </div>
                            <div class="bg-white flex-col justify-around p-2 rounded-b">

                                <div v-if="newlyCroppedImage" style="display: flex;position: relative;align-items: center;justify-content: center;">
                                    <img class="circle" :src="newlyCroppedImage"/>
                                </div>
                                <div v-else-if="company.photo_url" style="display: flex;position: relative;align-items: center;justify-content: center;">
                                    <img class="circle" :src="company.photo_url"/>
                                </div>
                                <!-- <div v-else-if="form.profileImage" style="display: flex;position: relative;align-items: center;justify-content: center;"> -->
                                <!--                                <span v-if="form.vanityName == 1">-->
                                <!--                                    <a :href="'https://www.linkedin.com/in/'+form.linkedin_vanity_name" style="left: 69%;top: 66%;color: rgb(0, 63, 103);position: absolute;" target="_blank" class=""><i class="fa fa-linkedin-square fa-2x"></i></a>-->
                                <!--                                </span>-->
                                <!--                                <span v-else>-->
                                <!--                                    <a :href="this.linkedinUrl" style="left: 69%;top: 66%;color: rgb(0, 63, 103);position: absolute;" class=""><i class="fa fa-linkedin-square fa-2x"></i></a>-->
                                <!--                                </span>-->
                                <!-- <img class="circle" :src="form.linkedin_profile_url"/>
                            </div> -->
                                <div v-else  style="display: flex;position: relative;align-items: center;justify-content: center;">
                                    <!--                                <a :href="this.linkedinUrl" style="color: #003f67; position: absolute;left: 69%; top: 66%;" class=""><i class="fa fa-linkedin-square fa-2x" ></i></a>-->
                                    <img v-if="form.scrFile == true" class="circle" :src="'https://logo.clearbit.com/'+form.domain_link"/>
                                    <span v-else class="circle" style="font-size: 65px;color: #fff;text-align: center;" v-bind:style="{ 'background': bgColorDark }">{{form.initals}}</span>
                                </div>

                                <div style="display: flex;position: relative;align-items: center;justify-content: center;bottom: 40px;left: 33px;">
                                    <span data-toggle="modal" data-target="#upload_photo" class="material-icons" style="cursor: pointer;background: #01b1af;border-radius: 25px;padding: 2px;color: white;">edit</span>
                                    <a style="cursor: pointer;position: absolute;left: 16px;z-index: 1;"
                                       v-if="company.linkedin_profile_url" :href="prepareLinkedInURL(company.linkedin_profile_url)"  target="_blank">
                                        <img src="/images/linkedin-icon.png" style="width: 50px">
                                    </a>
                                </div>

                                <div class="flex mb-3 leading-tight justify-between">
                                    <label class="text-grey-darkest text-sm" for="name">Company Name</label>
                                    <div class="flex-col w-3/5">
                                        <input v-model="form.name" type="text" name="name" id="name"
                                               class="rounded w-full py-1 px-2 leading-normal text-grey-darkest text-sm focus:outline-none border-1"
                                               :class="{'border-red': form.errors.has('name')}">
                                        <div class="text-red text-xs" v-if="form.errors.has('name')">
                                            {{ form.errors.get('name') }}
                                        </div>
                                    </div>
                                </div>
                                <div class="flex mb-3 leading-tight justify-between">
                                    <label class="text-grey-darkest text-sm" for="address">Address</label>
                                    <div class="flex-col w-3/5">
                                        <input v-model="form.address" type="text" name="address" id="searchTextField"
                                               class="rounded w-full py-1 px-2 leading-normal text-grey-darkest text-sm focus:outline-none border-1"
                                               :class="{'border-red': form.errors.has('address')}">
                                        <div class="text-red text-xs" v-if="form.errors.has('address')">
                                            {{ form.errors.get('address') }}
                                        </div>
                                        <input v-model="form.lat" type="hidden" name="lat"
                                               class="rounded w-full p-2 text-grey-darkest text-sm focus:outline-none border-1">
                                        <input v-model="form.lng" type="hidden" name="lng"
                                               class="rounded w-full p-2 text-grey-darkest text-sm focus:outline-none border-1">
                                    </div>
                                </div>
                                <div class="flex mb-2 flex-wrap">
                                    <div class="mb-2 pl-2 leading-tight w-1/3 pr-1">
                                        <label class="text-grey-darkest text-sm"
                                               :class="{'text-red' : form.errors.has('city')}" for="city">City</label>
                                        <input v-model="form.city" type="text" name="city" id="city"
                                               class="rounded w-full p-2 text-grey-darkest text-sm focus:outline-none border-1"
                                               :class="{'border-red': form.errors.has('city')}">
                                        <div class="text-red text-xs" v-if="form.errors.has('city')">{{
                                                form.errors.get('city')
                                            }}
                                        </div>
                                    </div>
                                    <div class="mb-2 leading-tight w-1/3 pr-1">
                                        <label class="text-grey-darkest text-sm"
                                               :class="{'text-red' : form.errors.has('state')}" for="state">State</label>
                                        <input v-model="form.state" type="text" name="state" id="state"
                                               class="rounded w-full p-2 text-grey-darkest text-sm focus:outline-none border-1"
                                               :class="{'border-red': form.errors.has('state')}">
                                        <div class="text-red text-xs" v-if="form.errors.has('state')">{{
                                                form.errors.get('state')
                                            }}
                                        </div>
                                    </div>
                                    <div class="mb-2 leading-tight w-1/3 pr-1">
                                        <label class="text-grey-darkest text-sm"
                                               :class="{'text-red' : form.errors.has('zip')}" for="zip">Zip</label>
                                        <input v-model="form.zip" type="text" name="zip" id="zip"
                                               class="rounded w-full p-2 text-grey-darkest text-sm focus:outline-none border-1"
                                               :class="{'border-red': form.errors.has('zip')}">
                                        <div class="text-red text-xs" v-if="form.errors.has('zip')">{{
                                                form.errors.get('zip')
                                            }}
                                        </div>
                                    </div>
                                </div>
                                <div class="flex mb-3 leading-tight justify-between">
                                    <label class="text-grey-darkest text-sm" for="phone">Phone</label>
                                    <div class="flex-col w-3/5">
                                        <div class="input-group">
                                            <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1">
                                            {{ symbols.DDI }}
                                        </span>
                                            </div>
                                            <input v-model="form.phone" type="text" name="phone" id="phone"
                                                   v-mask="masks.v_mask_phone"
                                                   class="form-control rounded w-full py-3 px-2 leading-normal text-grey-darkest  focus:outline-none border-1"
                                                   :class="{'border-red': form.errors.has('phone')}">
                                        </div>
                                        <div class="text-red text-xs" v-if="form.errors.has('phone')">
                                            {{ form.errors.get('phone') }}
                                        </div>
                                    </div>
                                </div>
                                <div class="flex mb-3 leading-tight justify-between">
                                    <label class="text-grey-darkest text-sm" for="fax">Fax</label>
                                    <div class="flex-col w-3/5">
                                        <input v-model="form.fax" type="text" name="fax" id="fax"
                                               v-mask="masks.v_mask_phone"
                                               class="rounded w-full py-1 px-2 leading-normal text-grey-darkest text-sm focus:outline-none border-1"
                                               :class="{'border-red': form.errors.has('fax')}">
                                        <div class="text-red text-xs" v-if="form.errors.has('fax')">
                                            {{ form.errors.get('fax') }}
                                        </div>
                                    </div>
                                </div>
                                <div class="flex mb-3 leading-tight justify-between">
                                    <label class="text-grey-darkest text-sm" for="fax">Web Site</label>
                                    <div class="flex-col w-3/5">
                                        <input v-model="form.site" type="text" name="site" id="site"
                                               class="rounded w-full py-1 px-2 leading-normal text-grey-darkest text-sm focus:outline-none border-1"
                                               :class="{'border-red': form.errors.has('site')}">
                                        <div class="text-red text-xs" v-if="form.errors.has('site')">
                                            {{ form.errors.get('site') }}
                                        </div>
                                    </div>
                                </div>
                                <div class="flex flex-row mb-3 justify-content-between">
                                    <label class="text-grey-darkest text-sm" for="fax">Company Type</label>
                                    <div class="flex-col w-3/5">
                                        <multiselect
                                            class="cursor-pointer"
                                            :options="companyTypes"
                                            v-model="selectedType"
                                            :show-labels="false"
                                            @input="form.errors.clear('company_type_id')"
                                            track-by="id"
                                            label="code"
                                            value="id">
                                        </multiselect>
                                        <div class="text-red-xs" v-if="form.errors.has('company_type_id')">
                                            {{ form.errors.get('company_type_id') }}
                                        </div>
                                    </div>
                                </div>
                                <div class="flex flex-row mb-3 justify-content-between">
                                    <label class="text-grey-darkest text-sm"
                                           :class="{'text-red': form.errors.has('team_company_status')}">Status</label>
                                    <div class="flex-col w-3/5">
                                        <select name="team_company_status" id="team_company_status" v-model="form.team_company_status"
                                                class="rounded w-full py-1 px-2 leading-normal text-grey-darkest text-sm focus:outline-none border-1"
                                        >
                                            <option selected></option>
                                            <option v-for="item in companyStatuses" :value="item.id">{{ item.name }}</option>
                                        </select>
                                        <div class="text-red" v-if="form.errors.has('team_company_status')">{{
                                                form.errors.get('team_company_status')
                                            }}
                                        </div>
                                    </div>
                                </div>
                                <div class="flex mb-3 leading-tight justify-between">
                                    <label class="text-grey-darkest text-sm" for="created_at">Created date</label>
                                    <div class="flex-col w-3/5">
                                        <input v-model="this.companyCreatedDate" type="text" name="created_at" id="created_at"
                                               class="rounded w-full py-1 px-2 leading-normal text-grey-darkest text-sm focus:outline-none border-1"
                                               :class="{'border-red': form.errors.has('created_at')}" disabled>
                                        <div class="text-red text-xs" v-if="form.errors.has('created_at')">
                                            {{ form.errors.get('created_at') }}
                                        </div>
                                    </div>
                                </div>
                                <div class="flex mb-3 leading-tight justify-between">
                                    <label class="text-grey-darkest text-sm" for="updated_at">Last update</label>
                                    <div class="flex-col w-3/5">
                                        <input v-model="this.companyUpdatedDate" type="text" name="updated_at" id="updated_at"
                                               class="rounded w-full py-1 px-2 leading-normal text-grey-darkest text-sm focus:outline-none border-1"
                                               :class="{'border-red': form.errors.has('updated_at')}" disabled>
                                        <div class="text-red text-xs" v-if="form.errors.has('updated_at')">
                                            {{ form.errors.get('updated_at') }}
                                        </div>
                                    </div>
                                </div>
                                <company-custom-fields ref="CompanyCustomFields" :company="company" :foundationCustomerAccess="foundationCustomerAccess" :foundationAutoGeneratedAccess="foundationAutoGeneratedAccess" base="edit" :spectrumCustomerCodeCustomFieldId="spectrumCustomerCodeCustomFieldId" :spectrumAccess="spectrumAccess" :spectrumCompanyMapping="spectrumCompanyMapping" @spectrum-customer-code-changed="spectrumCustomerCodeChanged" :agave-erp="agaveErp" :foundationCustomerNoCustomFieldId="foundationCustomerNoCustomFieldId" :foundationAccess="foundationAccess"></company-custom-fields>
                            </div>
                        </form>
                        <div v-if="!sharedCompanyObj.isSharedCompany" class="flex border-b-2 border-followup-nav text-grey-darkest rounded-t p-2 justify-between">
                            <span class="pl-2">Company Analytics</span>
                        </div>
                        <slot v-if="!sharedCompanyObj.isSharedCompany"></slot>
                        <div class="flex border-b-2 border-followup-nav text-grey-darkest rounded-t p-2 justify-between">
                            <span class="pl-2">Map</span>
                        </div>
                        <div id="map_company" style="height: 300px;"></div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="mr-3 rounded shadow-md bg-white p-0" :class="{'': !sharedCompanyObj.isSharedCompany, '': sharedCompanyObj.isSharedCompany}">
                        <div class="" style="display: inline-block;width: 100%;">
                            <div class="mb-2 w-full border-b-2 border-followup-nav contactTabs" style="min-height: 20px;height: fit-content">
                                <button v-for="tab in tabs" :key="tab" @click="selected = tab;"
                                        :class="['tab-btn', { activeTab: selected === tab }]">
                                    {{ (tab == 'ChildCompanyProjects')? 'Child Projects':tab }}
                                </button>
                                <!--                            <keep-alive>-->
                                <component :is="selected" :key="selected" class="tab p-0" is_client="true" :company="company" :relatedCompanies="form.relatedCompanies" :canEdit="canEdit" @companiesPushed="updateRelatedCompanies($event)" :sharedCompanyObj="sharedCompanyObj" :field-labels="fieldLabels" :user-role="userRole" :user="user" :team="team" :companyProjectState="companyProjectState" :companyProjectAvailableColumns="companyProjectAvailableColumns" :masks="masks" :calendar="calendar" :companyProjectAvailableSort="companyProjectAvailableSort" :companyChildProjectAvailableColumns="companyChildProjectAvailableColumns" :isChildProjectsTab="selected === 'ChildCompanyProjects'" :companyChildProjectState="companyChildProjectState"
                                           :recordDetailFieldLabels="recordDetailFieldLabels">
                                    <slot></slot>
                                </component>
                                <!--                            </keep-alive>-->
                            </div>
                        </div>
                        <div class="mb-3 w-full border-b-2 bg-primary contactTabs text-white py-2 px-3 mt-3" v-if="isQuickBookConnected && company.is_residential == 0">
                            Invoices <span class="cursor-pointer" @click="syncInvoices()"><i class="fa fa-refresh" aria-hidden="true"></i></span> <span v-if="quickBookInvoiceObj" class="float-right">Last Synced: {{ formatSyncedDate(quickBookInvoiceObj.updated_at) }}</span>
                        </div>
                        <div class="container overflow-scroll" v-if="isQuickBookConnected && company.is_residential == 0">
                            <table class="table table-bordered">
                                <thead>
                                <tr>
                                    <th>Invoice</th>
                                    <th>Balance</th>
                                    <th>Doc Number</th>
                                    <th>Due Date</th>
                                    <th>Total Amount</th>
                                    <th></th>
                                </tr>
                                </thead>
                                <tbody v-if="quickBookInvoiceData.length > 0">
                                <tr v-for="(invoice, index) in quickBookInvoiceData" class="cursor-pointer hover:bg-grey-lighter" @click="invoiceDetailModal(invoice)">
                                    <td>Invoice {{index+1}}</td>
                                    <td>${{ invoice.Balance }}</td>
                                    <td>{{ invoice.DocNumber }}</td>
                                    <td>{{ formatQuickBookDate(invoice.DueDate) }}</td>
                                    <td>${{ invoice.TotalAmt }}</td>
                                    <td class="text-center"><i class="fa fa-eye" aria-hidden="true"></i></td>
                                </tr>
                                </tbody>
                                <tbody v-else>
                                <tr>
                                    <td colspan="11" class="text-center">No invoices found in QB for this company/customer</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>

                    </div>

                </div>
                <div class="col-md-3" v-show="addCompanyContactAssociationStatus">
                    <div class=" overflow-auto rounded shadow-md bg-white p-3" >
                        <div class="row">
                            <div class="col-lg-11">
                                <b-tabs content-class="mt-3" lazy>
                                    <b-tab id="create-new-tab" title="Create New" class="card">
                                        <contact-create-form :company="company" :masks="masks" v-on:contactCreated="contactCreated"></contact-create-form>
                                    </b-tab>
                                    <b-tab id="add-existing-tab" title="Add Existing" >
                                        <div class="relative">
                                            <input type="text" class="w-full pr-10 pl-4 py-2 border rounded focus:outline-none" placeholder="Search a company..."
                                                   v-model="filter.company_name"
                                                   @input="debounceFilter">
                                            <div class="absolute" style="top: 6px; right: 35px;" v-if="isLoadingContacts">
                                                <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
                                            </div>
                                            <i class="absolute fa fa-search mt-2 mr-2 custom-search-icon" aria-hidden="true"></i>
                                        </div>
                                        <div class="flex justify-between" v-if="searchedCompanyContacts.length > 0 || searchSelectedCompanyContacts.length > 0 ">
                                            <div class="mb-1 text-grey-darkest text-sm">{{ searchedCompanyContacts.length }} results</div>
                                            <div class="mb-1 text-grey-darkest text-sm">{{ searchSelectedCompanyContacts.length }} selected</div>
                                        </div>
                                        <div v-if="searchSelectedCompanyContacts.length > 0">
                                            <label class="font-medium text-grey-darkest text-md mb-2">Selected</label>
                                            <div class="leading-tight selected-contact-result-section">
                                                <b-form-checkbox-group
                                                    v-model="searchSelectedCompanyContacts"
                                                >
                                                    <div class="flex justify-between mb-2 mr-2"  v-for="(selectedCompany, selectedCompanyIndex) in searchSelectedCompanyContacts">
                                                        <div class="flex w-3/5 align-items-center company-contact-select-checkbox">
                                                            <b-form-checkbox
                                                                class="confirm-checkbox"
                                                                :id="'company-selected-'+ selectedCompany.id"
                                                                :name="'company-selected-'+ selectedCompany.id"
                                                                :value="selectedCompany"
                                                                @change="removeSelectedCompany(selectedCompany)">
                                                            </b-form-checkbox>
                                                            <div class="mr-3 text-base text-grey-darkest ellipsis">{{ selectedCompany.name }}</div>
                                                        </div>
                                                        <div class="text-primary">{{ selectedCompany.company_name }}</div>
                                                    </div>
                                                </b-form-checkbox-group>
                                            </div>
                                        </div>
                                        <div v-if="searchedCompanyContacts.length > 0">
                                            <hr class="lg:hidden">
                                            <label class="font-medium text-grey-darkest text-md mb-2">All results</label>
                                            <div class="leading-tight contact-result-section">
                                                <b-form-checkbox-group
                                                    v-model="searchSelectedCompanyContacts"
                                                >
                                                    <div class="flex justify-between mb-2 mr-2"  v-for="(company, companyIndex) in searchedCompanyContacts">
                                                        <div class="d-flex flex-row align-items-center company-contact-select-checkbox">
                                                            <b-form-checkbox
                                                                class="confirm-checkbox"
                                                                :id="'company-select-'+ company.id"
                                                                :name="'company-select-'+ company.id"
                                                                :value="company"
                                                                :disabled="isCompanySelectionDisabled(company)">
                                                            </b-form-checkbox>
                                                            <div class="text-grey-darkest">{{ company.name }} {{isCompanySelectionDisabled(company) ? '(Already Associated)' : ''}}</div>
                                                        </div>
                                                        <div class="text-primary">{{ company.company_name }}</div>
                                                    </div>
                                                </b-form-checkbox-group>
                                            </div>
                                        </div>
                                        <!-- Add Existing content here -->
                                        <div v-if="searchSelectedCompanyContacts.length > 0" class="flex justify-content-end mt-3">
                                            <button @click="addAssociatedCompanyContact" class="btn border-1 border-grey mr-1 btn-primary" >Add Now</button>
                                        </div>
                                    </b-tab>
                                </b-tabs>
                            </div>
                            <div class="col-lg-1 p-0 text-left">
                                <div class="overflow-auto mt-3 bg-white" v-show="addCompanyContactAssociationStatus">
                                    <button class="no-btn-properties" @click="() => addCompanyContactAssociationStatus = false" style="color: black;">X</button>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="col-md-3" v-if="!addCompanyContactAssociationStatus">
                    <div  class="rounded shadow-md bg-white">
                        <div class="flex-col">
                            <div
                                class="flex border-b-2 border-followup-nav text-grey-darkest rounded-t p-2 justify-between">
                                <span class="pl-2">Contacts</span>

                                <div class="flex-1">
                                    <div class="bg-grey-lighter px-3 rounded-full mr-3 float-left" style="width:135px;">
                                        <input ref="filter" type="search"
                                               class="bg-grey-lighter focus:outline-none rounded text-sm text-grey-darkest"
                                               placeholder="Search Contacts" @input="debounceFilterContacts"
                                               v-model="contactFilter"
                                               style="width:100%">
                                        <i v-if="loadingContacts" class="fa fa-spin fa-spinner text-grey-darkest"
                                           aria-hidden="true"></i>
                                    </div>
                                    <button v-if="!sharedCompanyObj.isSharedCompany"
                                            class="border-2 border-followup-nav hover:bg-followup-nav rounded-full text-white text-sm">
                                        <button
                                            class="font-semibold hover:no-underline hover:text-white material-icons p-1 text-sm text-followup-nav" @click="showTabs()">add</button>
                                    </button>

                                </div>
                            </div>
                            <div class="rounded-b p-2">
                                <div class="card cursor-pointer hover:bg-grey-light w-full border-1" :class="(contact.team_contact_status_name !== 'Inactive') ? 'background-none' : 'inactive-background'" style="margin-bottom:5px"
                                     v-for="contact in contacts">
                                    <div class="row card-body text-left">
                                        <div class="col-10" @click.prevent.stop="editContact(contact)">
                                            <img v-if="company.quick_book_connected_company_contact == contact.id && company.is_residential == 0 && team.is_quick_book_connected" class="qb-small-logo" src="https://prod-followupcrm.s3.us-east-2.amazonaws.com/qb-logo-small.png">
                                            <span class="text-xs text-grey-darkest py-1" style="word-break: break-all">
                                        <span class="text-xs">{{ contact.name ? contact.name :'Name : ---'}}</span>
                                        </span><br>
                                            <span class="text-xs text-grey-darkest py-1" style="word-break: break-all">
                                        <span class="text-xs">{{ contact.email ? contact.email :'Email : ---'}}</span>
                                        </span><br>
                                            <span class="text-xs text-grey-darkest py-1" style="word-break: break-all">
                                        <span class="text-xs">{{ contact.cell ? symbols.currency_name == 'Dollars' ? contact.cell.replace(/^(\d{3})(\d{3})(\d{4}).*/, '($1) $2-$3') : contact.cell.replace(/[^\d]/g, "") : 'Phone : ---' }}</span>
                                        </span><br>
                                            <span class="text-xs text-grey-darkest py-1" style="word-break: break-all">
                                        <span class="text-xs"><strong>Primary Company: {{ contact.company && contact.company.name ? contact.company.name : '---' }}</strong></span>
                                        </span><br>
                                            <span class="text-xs text-grey-darkest py-1" style="word-break: break-all">
                                        <span class="text-xs">{{ contact.date ? dateFormat(contact.date) : 'Follow Up : ---'}}</span>
                                        </span><br>
                                            <span class="text-xs text-grey-darkest py-1" style="word-break: break-all">
                                        <span class="text-xs">Status : {{ contact.team_contact_status_name ? contact.team_contact_status_name : '---'}}</span>
                                        </span><br>
                                            <span class="text-green-foundation" v-if="foundationContactSyncAccess && contact.foundation_customer_no">Contact synced with Foundation</span><br>
                                            <span v-if="foundationContactSyncAccess && !contact.foundation_customer_no" class="center py-1 rounded-r pr-1">
                                            <button @click.prevent.stop="syncFoundationContact(contact)" class="px-2 py-1 border-1 border-followup-nav hover:bg-followup-nav hover:text-white text-followup-nav rounded-full focus:outline-none" style="font-size: 15px;">
                                                <i :class="'fa fa-spin fa-spinner text-grey-darkest push-to-foundation-loader-' + contact.id" aria-hidden="true" style="display: none;"></i>
                                                Push To Foundation
                                            </button>
                                        </span>
                                            <span class="text-green-foundation" v-if="sageIntacctContactSyncAccess && contact.sage_intacct_customer_no">Contact synced with Sage Intacct</span><br>
                                            <span v-if="sageIntacctContactSyncAccess && !contact.sage_intacct_customer_no" class="center py-1 rounded-r pr-1">
                                            <button @click.prevent.stop="syncSageIntacctContact(contact)" class="px-2 py-1 border-1 border-followup-nav hover:bg-followup-nav hover:text-white text-followup-nav rounded-full focus:outline-none" style="font-size: 15px;">
                                                <i :class="'fa fa-spin fa-spinner text-grey-darkest push-to-foundation-loader-' + contact.id" aria-hidden="true" style="display: none;"></i>
                                                Push To Sage Intacct
                                            </button>
                                        </span>
                                            <!--                                        <span v-if="vistaAccess && !contact.vista_customer_no && contact.team_contact_status_name !== 'Inactive'" class="center py-1 rounded-r pr-1">-->
                                            <!--                                            <button @click.prevent.stop="syncVistaContact(contact)" class="px-2 py-1 border-1 border-followup-nav hover:bg-followup-nav hover:text-white text-followup-nav rounded-full focus:outline-none" style="font-size: 15px;">-->
                                            <!--                                                <i :class="'fa fa-spin fa-spinner text-grey-darkest push-to-vista-loader-' + contact.id" aria-hidden="true" style="display: none;"></i>-->
                                            <!--                                                Push To Vista-->
                                            <!--                                            </button>-->
                                            <!--                                        </span>-->
                                            <span v-if="vistaAccess && contact.vista_customer_no && contact.team_contact_status_name !== 'Inactive' && vistaConnectionData.checkContactMappedField" class="center py-1 rounded-r pr-1 text-green-foundation">
                                                Contact synced with Vista
                                        </span>
                                            <span v-if="sageAccess && contact.sage_contact_no" class="center py-1 rounded-r pr-1 text-green-foundation">
                                                Contact synced with Sage 100
                                        </span>
                                            <span v-if="spectrumAccess && contact.spectrum_customer_no && contact.team_contact_status_name !== 'Inactive'" class="center py-1 rounded-r pr-1 text-green-foundation">
                                                Contact synced with Spectrum
                                        </span>
                                            <span v-if="foundationAccess && contact.foundation_customer_contact_no && contact.team_contact_status_name !== 'Inactive'" class="center py-1 rounded-r pr-1 text-green-foundation">
                                                Contact synced with Foundation
                                        </span>
                                            <span v-if="agaveErp && agaveErp.third_party_name == 'sage-300-cre' && contact.sage_cre_contact_no" class="center py-1 rounded-r pr-1 text-green-foundation">
                                                Contact synced with Sage 300
                                        </span>
                                        </div>

                                        <div class="col-2" style="padding:0px">
                                            <div v-if="contact.photo_url" style="display: flex;align-items: center;justify-content: center;">
                                                <img class="circle_contact_image" :src="contact.photo_url"/>
                                            </div>
                                            <span v-else class="circle_contact_image" style="font-size: 20px;color: #fff;    display: flex;align-items: center;justify-content: center;" v-bind:style="{ 'background': [findRandomInRange()] }">{{contact.name.replace(/\s/g, '').charAt(0)}}</span>
                                            <span class="center py-1 rounded-r pr-1">
                                            <button v-if="canDelete && !sharedCompanyObj.isSharedCompany" @click.prevent.stop="showDeleteContactModal(contact)" style="margin-left: 10px;"
                                                    class="material-icons text-xl text-grey-darkest hover:text-grey-darkest focus:outline-none">
                                                delete
                                            </button>
                                        </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>


                <!-- Tabs -->

            </div>

        </div>

        <div class="modal" id="exist_contact" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content" style="border-radius: 12px; overflow: hidden;width: 400px;">
                    <div class="modal-header">
                        <div class="row" style="height: 200px;">
                            <div class="col-md-12" style="text-align: center; font-size:25px; margin-top:15px;font-weight: bold;">This company already exists</div>
                            <div class="col-md-12" style="text-align: center;" data-dismiss="modal">
                                <button type="button" @click="pageReload" class="btn btn-primary" style="padding: 15px 40px;box-shadow: #989797 0px 0px 5px 2px;margin-right: 12px;"
                                > Cancel</button>
                                <button type="button" @click="contactDetails()" class="btn btn-default" style="padding: 15px 40px;box-shadow: #989797 0px 0px 5px 2px; background:rgb(152 151 151);color: white;"
                                >Add</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--Share Company Modal-->
        <div class="modal" id="shareCompanyModal" tabindex="-1" data-backdrop="static">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header bg-white">
                        <h5 class="modal-title">Share Company</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="getShareCompanyTeams()">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body bg-white">
                        <div class="row">
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 form-group">
                                <label for="user">Add Teams</label>
                                <multiselect
                                    class="cursor-pointer w-full"
                                    :options="teams"
                                    v-model="shareCompanyForm.teams"
                                    label="name"
                                    placeholder="Search and Select..."
                                    :multiple="true"
                                    track-by="id"
                                    :show-labels="false"
                                    value="id"
                                    @input="updateShareCompanyForm">
                                </multiselect>
                                <div class="text-red text-sm" v-if="shareCompanyForm.errors.has('teams')">{{
                                        shareCompanyForm.errors.get('teams') }}
                                </div>
                            </div>
                        </div>
                        <div v-if="shareCompanyForm.teams.length > 0" class="row border border-dark-light m-1 rounded">
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                <div class="row flex align-items-center py-2" v-for="team in shareCompanyForm.teams" :key="team.id">
                                    <div class="col-xs-7 col-sm-7 col-md-7 col-lg-7 col-xl-7">
                                        {{ team.name }}
                                    </div>
                                    <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3">
                                        <select id="teamSelect" v-model="team.access" @change="changeShareCompanyAccess(team, $event)" class="float-right">
                                            <option value="view">view only</option>
                                            <option value="edit">can edit</option>
                                        </select>
                                    </div>
                                    <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2">
                                        <i class="fa fa-trash pointer float-right trash-icon-team" aria-hidden="true" @click="removeSelectedTeam(team)"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer bg-white">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="getShareCompanyTeams()">Cancel</button>
                        <button type="button" class="btn btn-primary" @click="storeShareCompanyTeams()">Save</button>
                    </div>
                </div>
            </div>
        </div>

        <!--Invoice Detail Modal-->
        <div v-if="invoiceDetail" class="modal fade" id="invoiceDetailModal" tabindex="-1" role="dialog" aria-labelledby="invoiceDetailModalTitle" aria-hidden="true" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLongTitle">Invoice Detail</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body bg-white">
                        <h5 class="font-weight-light text-white bg-primary mx-3 p-2">Invoice Information</h5>
                        <div class="row mx-3 text-sm">
                            <div class="col-3 border-1 text-break  p-2 bg-grey-lighter">
                                Id
                            </div>
                            <div class="col-3 border-1 text-break  border-l-0 p-2 text-sm">
                                {{ (invoiceDetail)? invoiceDetail.Id:'' }}
                            </div>
                            <div class="col-3 border-1 text-break  p-2 bg-grey-lighter border-l-0">
                                Due Date
                            </div>
                            <div class="col-3 border-1 text-break  border-l-0 p-2 border-l-0">
                                {{ (invoiceDetail)? formatQuickBookDate(invoiceDetail.DueDate):'' }}
                            </div>
                        </div>
                        <div class="row mx-3 text-sm">
                            <div class="col-3 border-1 text-break  p-2 bg-grey-lighter border-t-0">
                                Doc Number
                            </div>
                            <div class="col-3 border-1 text-break  border-l-0 p-2 border-t-0">
                                {{ (invoiceDetail)? invoiceDetail.DocNumber:'' }}
                            </div>
                            <div class="col-3 border-1 text-break  p-2 bg-grey-lighter border-t-0 border-l-0">
                                Created Date
                            </div>
                            <div class="col-3 border-1 text-break  border-l-0 p-2 border-t-0 border-l-0">
                                {{ (invoiceDetail)? formatQuickBookDateTime(invoiceDetail.MetaData.CreateTime):'' }}
                            </div>
                        </div>
                        <div class="row mx-3 text-sm">
                            <div class="col-3 border-1 text-break  p-2 bg-grey-lighter border-t-0">
                                Last Updated Date
                            </div>
                            <div class="col-3 border-1 text-break  border-l-0 p-2 border-t-0 border-l-0">
                                {{ (invoiceDetail)? formatQuickBookDateTime(invoiceDetail.MetaData.LastUpdatedTime):'' }}
                            </div>
                            <div class="col-3 border-1 text-break  p-2 bg-grey-lighter border-t-0 border-l-0">
                                Balance
                            </div>
                            <div class="col-3 border-1 text-break  border-l-0 p-2 border-t-0 border-l-0">
                                {{ (invoiceDetail)? '$'+invoiceDetail.Balance:'' }}
                            </div>
                        </div>
                        <div class="row mx-3 text-sm">
                            <div class="col-3 border-1 text-break  p-2 bg-grey-lighter border-t-0">
                                Total Amount
                            </div>
                            <div class="col-3 border-1 text-break  border-l-0 p-2 border-t-0 border-l-0">
                                {{ (invoiceDetail)? '$'+invoiceDetail.TotalAmt:'' }}
                            </div>
                        </div>

                        <h5 v-if="invoiceDetail.Line.length > 0" class="font-weight-light text-white bg-primary mx-3 p-2 mt-4">Line Item Information</h5>
                        <div class="row mx-3 text-sm">
                            <div class="col-2 border-1 p-2 bg-grey-lighter">
                                Item
                            </div>
                            <div class="col-4 border-1 border-l-0 p-2 bg-grey-lighter">
                                Description
                            </div>
                            <div class="col-2 border-1 border-l-0 p-2 bg-grey-lighter">
                                Unit Price
                            </div>
                            <div class="col-2 border-1 border-l-0 p-2 bg-grey-lighter">
                                Quantity
                            </div>
                            <div class="col-2 border-1 border-l-0 p-2 bg-grey-lighter">
                                Amount
                            </div>
                        </div>
                        <div class="row mx-3 text-sm" v-for="(line, index) in invoiceDetail.Line" v-if="(invoiceDetail.Line.length-2) >= index">
                            <div class="col-2 border-1 p-2 border-t-0">
                                {{ line.SalesItemLineDetail.ItemRef.name }}
                            </div>
                            <div class="col-4 border-1 border-l-0 p-2 border-t-0">
                                {{ line.Description }}
                            </div>
                            <div class="col-2 border-1 border-l-0 p-2 border-t-0">
                                ${{ line.SalesItemLineDetail.UnitPrice }}
                            </div>
                            <div class="col-2 border-1 border-l-0 p-2 border-t-0">
                                {{ line.SalesItemLineDetail.Qty }}
                            </div>
                            <div class="col-2 border-1 border-l-0 p-2 border-t-0">
                                ${{ line.Amount }}
                            </div>
                        </div>
                        <div class="row mx-3 text-sm">
                            <div class="col-10 border-1 p-2 border-t-0 text-right bg-grey-lighter">
                                Sub Total
                            </div>
                            <div class="col-2 border-1 border-l-0 p-2 border-t-0">
                                ${{ invoiceDetail.Line[invoiceDetail.Line.length-1].Amount }}
                            </div>
                        </div>
                        <div class="row mx-3 text-sm">
                            <div class="col-10 border-1 p-2 border-t-0 text-right bg-grey-lighter">
                                Tax Amount
                            </div>
                            <div class="col-2 border-1 border-l-0 p-2 border-t-0">
                                ${{ (invoiceDetail.TxnTaxDetail)? invoiceDetail.TxnTaxDetail.TotalTax:0 }}
                            </div>
                        </div>
                        <div class="row mx-3 text-sm">
                            <div class="col-10 border-1 p-2 border-t-0 text-right bg-grey-lighter">
                                Total Amount
                            </div>
                            <div class="col-2 border-1 border-l-0 p-2 border-t-0">
                                {{ (invoiceDetail)? '$'+invoiceDetail.TotalAmt:'' }}
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade bd-example-modal-xl" id="upload_photo" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Update Company Image</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div class="modal-body text-center">
                        <div id="cropperModel" class="model_loader">
                            <div class="text-5xl text-teal text-center model_spinner">
                                <i class="fa fa-spin fa-spinner" aria-hidden="true"></i>
                            </div>
                        </div>
                        <vue-anka-cropper
                            :options="{
                                    aspectRatio: 1,
                                    closeOnSave: false,
                                    cropArea: 'circle',
                                    croppedHeight: 400,
                                    croppedWidth: 400,
                                    dropareaMessage: 'Upload file or drag and drop',
                                    frameLineDash: [0,0],
                                    frameStrokeColor: 'rgba(255, 255, 255, 1.0)',
                                    handleFillColor: 'rgba(255, 255, 255, 1.0)',
                                    handleHoverFillColor: 'rgba(255, 255, 255, 1.0)',
                                    handleHoverStrokeColor: 'rgba(255, 255, 255, 1.0)',
                                    handleSize: 13,
                                    handleStrokeColor: 'rgba(255, 255, 255, 0.1)',
                                    overlayFill: 'rgba(0, 0, 0, 0.1)',
                                    previewOnDrag: true,
                                    selectButtonLabel: 'Select File',
                                    showPreview: true,
                                    previewQuality: 1,
                                    resultQuality: 1,
                                    skin: 'light',
                                    layoutBreakpoint: 480,
                                    uploadData: {},
                                    uploadTo: false
                                }"
                            @cropper-error="handleCroppingError(errorMessage)"
                            @cropper-saved="getCroppedImage($event)"
                        ></vue-anka-cropper>
                    </div>
                </div>
            </div>
        </div>

        <MergeCompany v-if="showMergeCompanyForm" @modalClosed="showMergeCompanyForm = false" :primaryCompanyObj="company" ></MergeCompany>

        <!--Select Options for Quick Book Modal-->
        <div class="modal" id="optionsForQuickBookModal" tabindex="-1" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header bg-white">
                        <h5 class="modal-title">Select option for QuickBooks</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="selectOptionsForQuickBookClose()">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body bg-white">
                        <div class="row">
                            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 form-group">
                                <button type="button" class="btn btn-primary" @click="selectFromExistingQBCustomersModal()">Select from QuickBooks existing customers</button>
                            </div>
                            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 form-group">
                                <button type="button" class="btn btn-primary" @click="selectCompanyContactForQBModal()">Create new customer on QuickBooks</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--Select from existing QuickBook Customer-->
        <div class="modal" id="selectFromExistingQBCustomerModal" tabindex="-1" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">
                    <div class="modal-header bg-white">
                        <h5 class="modal-title">Select QuickBooks existing customer</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="selectFromExistingQBCustomersModalClose()">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body bg-white">
                        <span class="text-primary mb-3 cursor-pointer d-inline-block" @click="selectFromExistingQBCustomersModalClose()">
                        <i class="fa fa-chevron-left" aria-hidden="true"></i> Back
                        </span>
                        <div class="row">
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 form-group">
                                <label for="user">QuickBooks customers</label>
                                <multiselect
                                    class="cursor-pointer w-full"
                                    :options="quickBookCustomers"
                                    v-model="selectedQuickBookCustomer"
                                    label="DisplayName"
                                    placeholder="Search and Select..."
                                    :multiple="false"
                                    track-by="id"
                                    :show-labels="false"
                                    :taggable="true"
                                    :close-on-select="true"
                                >
                                </multiselect>
                            </div>
                        </div>
                        <div class="mt-2" v-if="selectedQuickBookCustomer">
                            <h5 class="font-weight-light text-white bg-primary mx-3 p-2">Customer Information</h5>
                            <div class="row mx-3 text-sm">
                                <div class="col-3 border-1 text-break  p-2 bg-grey-lighter">
                                    Display Name
                                </div>
                                <div class="col-3 border-1 text-break  border-l-0 p-2 text-sm">
                                    {{ selectedQuickBookCustomer.DisplayName }}
                                </div>
                                <div class="col-3 border-1 text-break  p-2 bg-grey-lighter border-l-0">
                                    Company Name
                                </div>
                                <div class="col-3 border-1 text-break  border-l-0 p-2 border-l-0">
                                    {{ selectedQuickBookCustomer.CompanyName }}
                                </div>
                            </div>
                            <div class="row mx-3 text-sm">
                                <div class="col-3 border-1 text-break  p-2 bg-grey-lighter border-t-0">
                                    QB Id
                                </div>
                                <div class="col-3 border-1 text-break  border-l-0 p-2 border-t-0">
                                    {{ selectedQuickBookCustomer.Id }}
                                </div>
                                <div class="col-3 border-1 text-break  p-2 bg-grey-lighter border-t-0 border-l-0">
                                    Created Date
                                </div>
                                <div class="col-3 border-1 text-break  border-l-0 p-2 border-t-0 border-l-0">
                                    {{ (selectedQuickBookCustomer.MetaData)? formatQuickBookDateTime(selectedQuickBookCustomer.MetaData.CreateTime):'' }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" @click="selectQBCustomer()">Select Customer</button>
                    </div>
                </div>
            </div>
        </div>

        <!--Contact Selection for QuickBook customer creation-->
        <div class="modal" id="selectCompanyContactForQBModal" tabindex="-1" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">
                    <div class="modal-header bg-white">
                        <h5 class="modal-title">Select company contact for QuickBooks</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="selectCompanyContactForQBModalClose()">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body bg-white">
                        <span class="text-primary mb-3 cursor-pointer d-inline-block" @click="selectCompanyContactForQBModalClose()">
                        <i class="fa fa-chevron-left" aria-hidden="true"></i> Back
                        </span>
                        <div class="row">
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 form-group">
                                <label for="user">Company contacts</label>
                                <multiselect
                                    class="cursor-pointer w-full"
                                    :options="contacts"
                                    v-model="selectedCompanyContactForQB"
                                    label="name"
                                    placeholder="Search and Select..."
                                    :multiple="false"
                                    track-by="id"
                                    :show-labels="false"
                                    :taggable="true"
                                    :close-on-select="true"
                                >
                                </multiselect>
                            </div>
                        </div>
                        <div class="mt-2" v-if="selectedCompanyContactForQB">
                            <h5 class="font-weight-light text-white bg-primary mx-3 p-2">Contact Information</h5>
                            <div class="row mx-3 text-sm">
                                <div class="col-3 border-1 text-break  p-2 bg-grey-lighter">
                                    Name
                                </div>
                                <div class="col-3 border-1 text-break  border-l-0 p-2 text-sm">
                                    {{ selectedCompanyContactForQB.name }}
                                </div>
                                <div class="col-3 border-1 text-break  p-2 bg-grey-lighter border-l-0">
                                    Company Name
                                </div>
                                <div class="col-3 border-1 text-break  border-l-0 p-2 border-l-0">
                                    {{ selectedCompanyContactForQB.company.name }}
                                </div>
                            </div>
                            <div class="row mx-3 text-sm">
                                <div class="col-3 border-1 text-break  p-2 bg-grey-lighter border-t-0">
                                    Email
                                </div>
                                <div class="col-3 border-1 text-break  border-l-0 p-2 border-t-0">
                                    {{ selectedCompanyContactForQB.email }}
                                </div>
                                <div class="col-3 border-1 text-break  p-2 bg-grey-lighter border-t-0 border-l-0">
                                    Phone
                                </div>
                                <div class="col-3 border-1 text-break  border-l-0 p-2 border-t-0 border-l-0">
                                    {{ selectedCompanyContactForQB.cell }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" @click="createCustomerToQB()">Create Customer</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Delete Contact Confirmation Modal -->
        <div class="modal" id="deleteContactModal" tabindex="-1" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ (deleteableContact && deleteableContact.is_primary) ? 'Delete Permanently?' : 'Remove Association?' }}</h5>
                        <button type="button" class="close" @click="hideDeleteContactModal()" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p v-if="deleteableContact && deleteableContact.is_primary">This will delete the contact {{ (deleteableContact && deleteableContact.name) ? deleteableContact.name : '' }} permanently from Followup CRM. Do you want to continue?</p>
                        <p v-else-if="deleteableContact && !deleteableContact.is_primary">This contact {{ (deleteableContact && deleteableContact.name) ? deleteableContact.name : '' }} will not longer be associated with {{ company.name }}.</p>
                    </div>
                    <div class="modal-footer">
                        <button class="no-btn-properties mx-4" @click="hideDeleteContactModal()">Cancel</button>
                        <button type="button" class="btn btn-danger" v-on="deleteableContact ? (deleteableContact.is_primary ? { click: () => deleteContact() } : { click: () => removeAssociatedContact() }) : {}">Confirm</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

import Form from "../../utils/form";
import Multiselect from 'vue-multiselect';
import Notes from "../company/company-notes";
import Companies from "../company/related-companies";
import Projects from "../company/recent-projects";
import ChildCompanyProjects from "../company/recent-projects";
import CompanyCustomFields from "./custom-fields/company-custom-fields";
import Swal from "sweetalert2";
import vueAnkaCropper from 'vue-anka-cropper';
import MergeCompany from "./merge-company";
import axios from "axios";
import ContactCreateForm from "../contact/contact-create-form.vue";

let autocomplete=null;
var x = 137;
var y = 100+ Math.floor(Math.random() * 256);
var z = 50+ Math.floor(Math.random() * 256);
export default {
    name: 'company-show',
    props: ['agaveErp','sageAccess','sageCompanyMapping','company', 'masks', 'symbols', 'relatedCompanies', 'canEdit','linkedinUrl', 'canDelete', 'teams', 'sharedCompanyObj', 'team', 'companyStatuses', 'fieldLabels', 'userRole', 'sageIntacctContactSyncAccess', 'foundationContactSyncAccess', 'foundationPullDataAccess', 'foundationCustomerAccess', 'foundationAutoGeneratedAccess', 'vistaAccess', 'quickBookInvoices', 'quickBookAccess', 'childCompany', 'user', 'spectrumAccess', 'spectrumCompanyMapping', 'spectrumCustomerCodeCustomFieldId','foundationAccess','foundationCompanyMapping','foundationCustomerNoCustomFieldId', 'companyProjectState', 'companyProjectAvailableColumns', 'calendar', 'companyProjectAvailableSort', 'companyChildProjectAvailableColumns', 'companyChildProjectState', 'companyContactVistaHistory',
        'recordDetailFieldLabels', 'companyErpSyncSettings', 'erpConnections', 'canErpCreate', 'canErpUpdate', 'canErpSync'],
    components: {Notes,Multiselect, Companies,Projects,CompanyCustomFields,vueAnkaCropper,ChildCompanyProjects,MergeCompany, ContactCreateForm},

    data() {
        return {
            form: new Form({
                id: this.company.id,
                name: this.company.name,
                company_types_id: this.company.company_types_id,
                initals: this.company.name.replace(/\s/g, '').charAt(0),
                address: this.company.address,
                city: this.company.city,
                state: this.company.state,
                lat: this.company.lat,
                lng: this.company.lng,
                zip: this.company.zip ? this.company.zip.replace(/\D/g, '') : '',
                phone: this.company.phone ? this.company.phone.replace(/\D/g, '') : '',
                fax: this.company.fax,
                site: this.company.site,
                domain_link: this.company.site,
                linkedin_profile_url: this.company.linkedin_profile_url,
                profileImage: this.company.linkedin_profile_url ? 1 : '',
                linkedin_vanity_name: this.company.linkedin_vanity_name,
                vanityName: this.company.linkedin_vanity_name ? 1 : '',
                company_id: null,
                team_company_status:this.company.team_company_status,
                // company_types_id: this.company_type,
                relatedCompanies: this.relatedCompanies ?? [],
                scrFile: false,
                customFieldsData: null,
            }),
            newlyCroppedImage : null,
            updatePhotoRoute : route('api.company.updatePhoto', {company: this.company.id}),
            currentProjectOrder: {
                property: 'sequential_team_id',
                direction: 'desc'
            },
            contacts: [],
            notes: null,
            contactFilter: '',
            noteFilter: '',
            selectedType: null,
            tabs: ["Notes", "Companies","Projects", "ChildCompanyProjects"],
            selected: (this.childCompany == true)? "Companies":"Notes",
            loadingContacts: true,
            loadingProjects: true,
            loadingNotes: true,
            companyTypes: [],
            companyTypeSelected: null,
            companyCreatedDate: null,
            companyUpdatedDate: null,
            bgColorDark : "rgb(" + x + "," + y + "," + z + ")",
            shareCompanyForm: new Form({
                teams: [],
                company_id: this.company.id
            }),
            syncFromFoundationLoading: false,
            quickBookInvoiceObj: this.quickBookInvoices ?? null,
            quickBookInvoiceData: (this.quickBookInvoices)? JSON.parse(this.quickBookInvoices.quick_book_invoice_data):[],
            invoiceDetail: null,
            isQuickBookConnected: (this.company.quick_book_connected == 1)? true:false,
            connectingQuickBook: false,
            quickBookCustomers: [],
            selectedQuickBookCustomer: null,
            connectedQBCustomer: this.company.quick_book_customer_id,
            selectedCompanyContactForQB: null,
            showMergeCompanyForm : false,
            deleteableContact: null,
            addCompanyContactAssociationStatus: false,
            filter: {
                company_name: '',
                timeout: null,
            },
            isLoadingContacts: false,
            searchedCompanyContacts: [],
            searchSelectedCompanyContacts: [],
            vistaConnectionData:{
                vistaCompanyMapping: null,
                checkContactMappedField: null,
                erpSyncSettings: null
            },
        }
    },

    mounted() {
        if (this.form.lat != null){
            var lattitude = this.form.lat;
        }else {
            var lattitude = 40.447711;
        }
        if (this.form.lng != null){
            var longititude = this.form.lng;
        }else {
            var longititude = -73.8996767;
        }
        this.address = this.form.address;
        this.initAutocomplete();
        this.companyCreatedDate = this.company.created_at ? moment(this.company.created_at).utc(1).format("MM-DD-YYYY hh:mm A") : null;
        this.companyUpdatedDate = this.company.updated_at ? moment(this.company.updated_at).utc(1).format("MM-DD-YYYY hh:mm A") : null;
        var uluru = {lat: Number(lattitude), lng: Number(longititude)};
        var map = new google.maps.Map(document.getElementById('map_company'), {
            zoom: 10,
            center: uluru
        });
        var marker = new google.maps.Marker({
            position: uluru,
            map: map,
        });
        this.getShareCompanyTeams();
        if(this.sharedCompanyObj.isSharedCompany) {
            this.tabs = ["Notes"];
        }
        if(this.companyErpSyncSettings){
            this.erpSyncSettings = this.companyErpSyncSettings
        }
        Bus.$on('vistaCheckContactMappedFieldChanged', data =>{
            this.vistaConnectionData = data
        })
    },
    watch: {
        selectedType(val) {
            this.form.company_types_id = val ? val.id : null;
        },
        // 'form.site': function (value) {
        //     this.scrFileStatus();
        // },
    },
    created() {
        this.fetchData();
        this.scrFileStatus();
    },
    methods: {
        prepareLinkedInURL(url)  {
            let baseUrl = "https://www.linkedin.com/";
            if (!url.startsWith(baseUrl) && !url.startsWith("www.linkedin.com/") && !url.startsWith("linkedin.com/")) {
                url = baseUrl + url;
            }
            return url;
        },
        scrFileStatus()  {
            const self = this;
            var imageUrl = 'https://logo.clearbit.com/'+self.form.domain_link;
            self.imageExists(imageUrl, function(exists) {
                self.scrFileExists(exists);
            });
        },
        imageExists(url, callback) {
            var img = new Image();
            img.onload = function() { callback(true); };
            img.onerror = function() { callback(false); };
            img.src = url;
        },
        scrFileExists(exists){
            this.form.scrFile = exists;
        },
        handleCroppingError(errorMessage){
            Swal.fire("Uh oh!", errorMessage, "error");
        },
        getCroppedImage(event){
            $('#cropperModel').fadeIn();
            let formData = new FormData();
            formData.append('photo', event.croppedFile);
            axios.post(route('api.company.updatePhoto', {company: this.company.id}),formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then((response) => {
                this.newlyCroppedImage = event.croppedImageURI;
                $('#cropperModel').fadeOut();
                $('#upload_photo').modal('hide');
            });
        },
        initAutocomplete() {
            let input = document.getElementById('searchTextField');
            autocomplete = new google.maps.places.Autocomplete(input, {
                componentRestrictions: {
                    country: ['us','ca']
                }
            });
            google.maps.event.addListener(autocomplete, 'place_changed', this.getAddressComponents);
        },
        getAddressComponents() {
            let placeResultData = autocomplete.getPlace();
            this.form.lat = placeResultData.geometry.location.lat();
            this.form.lng = placeResultData.geometry.location.lng();
            this.form.zip = '';
            this.form.city = '';
            this.form.state = '';
            var myLatLng = {lat: this.form.lat, lng: this.form.lng};
            var map = new google.maps.Map(document.getElementById('map_company'), {
                zoom: 10,
                center: myLatLng
            });
            var marker = new google.maps.Marker({
                position: myLatLng,
                map: map,
            });
            placeResultData.address_components.map(res=>{
                if(res.types[0]==='postal_code'){
                    this.form.zip = res.short_name;
                }
                if(res.types[0]==='locality'){
                    this.form.city = res.short_name;
                }
                if(res.types[0]==='administrative_area_level_1'){
                    this.form.state = res.short_name;
                }
            });
            this.form.address = placeResultData.name;
            this.address = placeResultData.name
        },
        getAddress: function (addressData){
            if(addressData.newVal===""){
                this.form.state='';
                this.form.city='';
                this.form.zip='';
            }
            this.address=addressData;
            const shortAddress  = addressData.newVal.split(",");
            this.form.address = shortAddress[0];
        },
        findRandomInRange() {
            var a = 50+ Math.floor(Math.random() * 256);
            var b = 50+ Math.floor(Math.random() * 256);
            var c = 100+ Math.floor(Math.random() * 256);
            return "rgb(" + a + "," + b + "," + c + ")";
        },
        fetchData() {
            this.fetchContacts();
            this.getCompanyTypes();
        },

        fetchContacts() {
            this.loadingContacts = true;
            axios.get(route('api.company.contacts', {
                company: this.company.id,
                filter: this.contactFilter
            })).then(({data}) => {
                this.contacts = data.data;
                this.loadingContacts = false;
                setTimeout(() => {
                    $('.vistaTooltip').tooltip();
                }, 2000);
            });
        },

        goToPage(page) {
            this.projectPagination.meta.current_page = page;
            this.fetchProjects();
        },

        fetchNotes() {
            this.loadingNotes = true;
            axios.get(route('api.company.notes', {
                company: this.company.id,
                filter: this.noteFilter
            })).then(({data}) => {
                this.notes = data;
                this.loadingNotes = false;
            });
        },

        debounceFilterContacts: _.debounce(function (e) {
            this.contactFilter = e.target.value;
            this.fetchContacts();
        }, 500),

        debounceFilterProjects: _.debounce(function (e) {
            this.projectFilter = e.target.value;
            this.fetchProjects()
        }, 500),

        debounceFilterNotes: _.debounce(function (e) {
            this.noteFilter = e.target.value;
            this.fetchNotes();
        }, 500),

        destroy() {
            Swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#01B1AF',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.value) {
                    axios.post(route('api.company-project-check', {company_id: this.company.id})).then(({data}) => {
                        if (data.exists){
                            Swal.fire({
                                title: 'Related Projects Exists!',
                                text: 'There are projects connected to this company. Are you sure you want to continue deleting and removing this company from all related projects?',
                                type: 'warning',
                                showCancelButton: true,
                                confirmButtonColor: '#01B1AF',
                                confirmButtonText: 'Yes, continue',
                                closeOnConfirm: false,
                            }).then((resultOther) => {
                                if (resultOther.value) {
                                    this.deteleAfterCheck();
                                }
                            });
                        }
                        else {
                            this.deteleAfterCheck();
                        }
                    });
                }
            });
        },
        deteleAfterCheck(){
            window.axios.delete(route('api.company.destroy', {company: this.company.id})).then(() => {
                this.getToast().fire({
                    type: 'success',
                    title: 'Your company has been deleted'
                });
                window.location = route('company.index');
            });
        },
        deleteContact() {
            let self = this;
            if(self.deleteableContact && self.deleteableContact.id) {
                if(self.deleteableContact.agave_customer_no && self.deleteableContact.vista_customer_no && self.vistaConnectionData.checkContactMappedField){
                    Swal.fire({
                        title: 'Uh oh!',
                        text: "Contact is synced with Vista. Please push another contact and then try again.",
                        type: 'error',
                        showCancelButton: false,
                        confirmButtonColor: '#01B1AF',
                    });
                    self.hideDeleteContactModal();
                }else{
                    axios.delete(route('api.contact.destroy', {contact: self.deleteableContact.id})).then((data) => {
                        self.hideDeleteContactModal();
                        if (data.data.status === "error") {
                            Swal.fire("Uh oh!", data.data.message, "error");
                        } else {
                            this.getToast().fire({
                                type: 'success',
                                title: 'Your contact has been deleted'
                            });
                            window.location.reload();
                        }
                    });
                }
            }
        },

        submitForm() {
            let self = this;
            self.form.customFieldsData = self.$refs.CompanyCustomFields.form;

            this.form.put(route('api.company.update', {company: this.company.id})).then((data) => {
                if (data.exists){
                    this.form.company_id = data.company_id;
                    $('#exist_contact').modal('show');
                }else {
                    this.$refs.CompanyCustomFields.submit(self.company.id, data.foundationCustomerNo, data.oldCompany ?? null);
                    this.getToast().fire({
                        type: 'success',
                        title: data.message
                    });
                    if(self.foundationCustomerAccess && !data.foundationCustomerNo && data.foundationMsg !== '') {
                        this.getToast().fire({
                            type: 'error',
                            title: data.foundationMsg
                        });

                        if(this.agaveErp && this.isCompanyERPSynced() && this.isERPSyncSettingActionUpdate()) {
                            this.syncCompanyToEnabledERP();
                        }
                        else {
                            window.location = route('company.show', {company: self.company.id});
                        }
                    }
                    else {
                        if(this.agaveErp && this.isCompanyERPSynced() && this.isERPSyncSettingActionUpdate()) {
                            this.syncCompanyToEnabledERP();
                        }
                        else {
                            window.location = route('company.show', {company: self.company.id});
                        }
                    }
                }
            });
        },
        pageReload(){
            if(this.agaveErp && this.isERPSyncSettingActionUpdate() && this.isCompanyERPSynced()) {
                this.syncCompanyToEnabledERP();
            }
            else {
                window.location.reload();
            }
        },
        contactDetails(){
            window.location = "/company/" + this.form.company_id;
        },
        print() {
            let newwindow = window.open(`/company/print?company_id=${this.company.id}`, 'print', 'width=860,height=740,toolbar=0,menubar=0,location=0');
            if (window.focus) {
                newwindow.focus()
            }
        },

        addProject() {
            window.location = route('project.create', {company_id: this.company.id});
        },

        editProject(project) {
            window.location = route('project.edit', {project: project.id, company_id: this.company.id});
        },

        editContact(contact) {
            window.location = route('contact.edit', {company: this.company.id, contact: contact.id});
        },

        sortByColumn(sortBy) {
            if (sortBy === this.currentProjectOrder.property) {
                this.currentProjectOrder.direction = (this.currentProjectOrder.direction === 'asc') ? 'desc' : 'asc'
            } else {
                this.currentProjectOrder.property = sortBy
                this.currentProjectOrder.direction = 'desc';
            }
            this.fetchProjects();
        },

        orderProjects(selectedProperty) {
            let newDirection = null;

            if (selectedProperty === this.currentProjectOrder.property) {
                newDirection = this.currentProjectOrder.direction === 'desc' ? 'asc' : 'desc';
            } else {
                newDirection = 'asc';
            }

            this.currentProjectOrder = {property: selectedProperty, direction: newDirection};

            this.projects = _.orderBy(this.projects, p => {
                switch (selectedProperty) {
                    case 'sequential_team_id':
                        return Number(p[selectedProperty]);
                    case 'bid_date':
                        return new Date(p[selectedProperty]);
                    case 'base_bid':
                        return Number(p[selectedProperty].toString().replace(',', ''));
                    case 'contract_date':
                        return new Date(p[selectedProperty]);
                    case 'contract_amount':
                        return Number(p[selectedProperty].toString().replace(',', ''));
                    default:
                        return p[selectedProperty];
                }
            }, newDirection);
        },

        dateFormat(date) {
            return date ? new Date(date).toLocaleDateString([], {hour: '2-digit', minute: '2-digit'}) : '';
        },


        updateRelatedCompanies(e){
            this.form.relatedCompanies = e;
        },
        getCompanyTypes() {
            let self = this;
            axios.get(route('api.settings.codes.company-type.index', {company_id:self.company.id}) ).then(({data}) => {
                self.companyTypes = data;
                self.companyTypes.push({id: null, code: ""})
            }).finally(() => {
                if (self.company.company_types_id)
                    self.selectedType = self.companyTypes.find((company) => {
                        return self.company.company_types_id === company.id
                    });
                else
                    self.selectedType = null;
            });
        },
        shareModal() {
            $('#shareCompanyModal').modal('show');
        },
        removeSelectedTeam(team) {
            let self = this;
            self.shareCompanyForm.teams = $.grep(self.shareCompanyForm.teams, function(e){
                return e.id != team.id;
            });
        },
        storeShareCompanyTeams() {
            let self = this;
            self.shareCompanyForm.post(route('api.share.company.store.or.update')).then((response) => {
                self.getToast().fire({
                    type: 'success',
                    title: 'Company shared with teams successfully!'
                });
                $('#shareCompanyModal').modal('hide');
            });
        },
        updateShareCompanyForm(event) {
            let self = this;
            self.shareCompanyForm.errors.clear('teams');
            self.shareCompanyForm.teams = self.shareCompanyForm.teams.map(value => {
                if(!value.hasOwnProperty('access')) {
                    value.access = 'view';
                }
                return value;
            });
        },
        changeShareCompanyAccess(team, event) {
            let self = this;
            let value = event.target.value;
            _.set(_.find(self.shareCompanyForm.teams, {id: team.id}), 'access', value);
        },
        getShareCompanyTeams() {
            let self = this;
            axios.get(route('api.share.company.index', {'company_id': self.company.id})).then(({data}) => {
                self.shareCompanyForm.teams = data.data;
            });
        },
        syncFoundationContact(contact) {
            let self = this;
            $('.push-to-foundation-loader-' + contact.id).show();
            let payload = {'team': self.team, 'company': self.company, 'contact': contact};
            let foundationSyncedContact = _.find(self.contacts, function(contact) {
                return contact.foundation_customer_no !== null;
            });
            if(foundationSyncedContact !== null && foundationSyncedContact !== undefined) {
                Swal.fire({
                    title: 'Sync Contact in Foundation',
                    text: "A customer record already exists on Foundation with this customer number & company name. Do you want to replace this customer record with this contact?",
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonColor: '#01B1AF',
                    confirmButtonText: 'Continue sync!'
                }).then((result) => {
                    if (result.value) {
                        axios.post(route('api.company.sync-foundation-contact'), payload).then((result) => {
                            $('.push-to-foundation-loader-' + contact.id).show();
                            this.getToast().fire({
                                type: 'success',
                                title: result.data.foundationCustomerNo ? result.data.message : result.data.foundationMsg,
                            });
                            if(result.data.foundationCustomerNo) {
                                window.location.reload();
                            }
                            else {
                                $('.push-to-foundation-loader-' + contact.id).hide();
                            }
                        }).catch(() => {
                            $('.push-to-foundation-loader-' + contact.id).hide();
                            this.getToast().fire({
                                type: 'error',
                                title: 'Create/Update on Foundation Failed.'
                            });
                        });
                    }
                    else {
                        $('.push-to-foundation-loader-' + contact.id).hide();
                    }
                });
            }
            else {
                axios.post(route('api.company.sync-foundation-contact'), payload).then((result) => {
                    $('.push-to-foundation-loader-' + contact.id).show();
                    this.getToast().fire({
                        type: 'success',
                        title: result.data.foundationCustomerNo ? result.data.message : result.data.foundationMsg,
                    });
                    if(result.data.foundationCustomerNo) {
                        window.location.reload();
                    }
                    else {
                        $('.push-to-foundation-loader-' + contact.id).hide();
                    }
                }).catch(() => {
                    $('.push-to-foundation-loader-' + contact.id).hide();
                    this.getToast().fire({
                        type: 'error',
                        title: 'Create/Update on Foundation Failed.'
                    });
                });
            }
        },

        syncSageIntacctContact(contact) {
            let self = this;
            $('.push-to-foundation-loader-' + contact.id).show();
            let sageIntactSyncedContact = _.find(self.contacts, function(contact) {
                return contact.sage_intacct_customer_no != null;
            });
            if(sageIntactSyncedContact !== null && sageIntactSyncedContact !== undefined) {
                let payload = {'team': self.team, 'company': self.company, 'contact': contact,'sageIntactSyncedContact': sageIntactSyncedContact};
                Swal.fire({
                    title: 'Push Contact in Sage Intacct',
                    text: "A customer record already exists on Sage Intacct with this customer number & company name. Do you want to replace the existing Primary Contact on Sage Intaact?",
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonColor: '#01B1AF',
                    confirmButtonText: 'Continue push!'
                }).then((result) => {
                    if (result.value) {
                        axios.post(route('api.company.sync-sage-intact-contact'), payload).then((result) => {
                            $('.push-to-foundation-loader-' + contact.id).show();
                            this.getToast().fire({
                                type: 'success',
                                title: result.data.sageInacctCustomerNo ? result.data.sageInacctMsg : result.data.message
                            });
                            if(result.data.sageInacctCustomerNo) {
                                window.location.reload();
                            }
                            else {
                                $('.push-to-foundation-loader-' + contact.id).hide();
                            }
                        }).catch(() => {
                            $('.push-to-foundation-loader-' + contact.id).hide();
                            this.getToast().fire({
                                type: 'error',
                                title: 'Create on Sage Intacct Failed'
                            });
                        });
                    }
                    else {
                        $('.push-to-foundation-loader-' + contact.id).hide();
                    }
                });
            }
            else {
                let payload = {'team': self.team, 'company': self.company, 'contact': contact,'sageIntactSyncedContact': null};
                axios.post(route('api.company.sync-sage-intact-contact'), payload).then((result) => {
                    $('.push-to-foundation-loader-' + contact.id).show();
                    this.getToast().fire({
                        type: 'success',
                        title: result.data.sageInacctCustomerNo ? result.data.sageInacctMsg : result.data.message,
                    });
                    if(result.data.sageInacctCustomerNo) {
                        window.location.reload();
                    }
                    else {
                        $('.push-to-foundation-loader-' + contact.id).hide();
                    }
                }).catch(() => {
                    $('.push-to-foundation-loader-' + contact.id).hide();
                    this.getToast().fire({
                        type: 'error',
                        title: 'Create on Sage Intacct Failed'
                    });
                });
            }
        },
        syncFromFoundationValidation() {
            let self = this;
            self.syncFromFoundationLoading = true;
            let payload = {'company': self.company, 'customFieldsData': self.$refs.CompanyCustomFields.form};
            axios.post(route('api.company.sync-from-foundation-validation'), payload).then((data) => {
                if(data.data.pass) {
                    if(data.data.message == '') {
                        self.syncFromFoundation(data.data.customerNo);
                    }
                    else {
                        Swal.fire({
                            title: 'Foundation',
                            text: data.data.message,
                            type: 'warning',
                            showCancelButton: true,
                            confirmButtonColor: '#01B1AF',
                            confirmButtonText: 'Confirm'
                        }).then((result) => {
                            if (result.value) {
                                self.syncFromFoundation(data.data.customerNo);
                            }
                        });
                    }
                }
                else {
                    self.syncFromFoundationLoading = false;
                    this.getToast().fire({
                        type: 'error',
                        title: data.data.message,
                    });
                }
            }).catch((error) => {
                self.syncFromFoundationLoading = false;
                this.getToast().fire({
                    type: 'error',
                    title: 'Some error occurred!'
                });
            });
        },
        syncFromFoundation(customerNo) {
            let self = this;
            let payload = {'company': self.company, 'customerNo': customerNo};

            axios.post(route('api.company.sync-from-foundation'), payload).then((data) => {
                self.syncFromFoundationLoading = false;
                if(data.data.success) {
                    this.getToast().fire({
                        type: 'success',
                        title: data.data.message
                    });
                    window.location.reload();
                }
                else {
                    window.location.reload();
                }
            }).catch((error) => {
                self.syncFromFoundationLoading = false;
            });
        },



        fetchInvoices(){
            let self = this;
            if(self.contacts.length == 0){
                self.getToast().fire({
                    type: 'error',
                    title: 'No contact added to this company.'
                });
                return false;
            }
            self.connectingQuickBook = true;
            let payload = {'company': self.company };
            axios.post(route('quick-book.fetch-invoices'), payload).then(response => {
                if(response.data.status == 'success'){
                    self.getToast().fire({
                        type: 'success',
                        title: response.data.message
                    });
                    self.quickBookInvoiceObj = response.data.quickBookInvoices;
                    self.quickBookInvoiceData = JSON.parse(response.data.quickBookInvoices.quick_book_invoice_data);
                    self.connectedQBCustomer = response.data.connectedCustomerId;
                    self.isQuickBookConnected = true;
                    setTimeout(() => {
                        window.location.reload();
                    }, 1500);
                }else{
                    self.getToast().fire({
                        type: 'error',
                        title: response.data.message
                    });
                    self.quickBookCustomers = response.data.quickBookCustomers
                    self.selectOptionsForQuickBook();
                }
                self.connectingQuickBook = false;
            });
        },
        formatQuickBookDate(date){
            return moment(date).format("MM-DD-yyyy");
        },
        formatQuickBookDateTime(date){
            return moment(date).format("MM-DD-yyyy h:mm a");
        },
        invoiceDetailModal(invoice){
            this.invoiceDetail = invoice;
            this.$nextTick(() => {
                $('#invoiceDetailModal').modal('show');
            });
        },
        disconnectQuickBook(){
            let self = this;
            let payload = {'company': self.company, 'quickBookInvoiceId': (self.quickBookInvoiceObj)? self.quickBookInvoiceObj.id:null };
            axios.post(route('quick-book.disconnect'), payload).then(response => {
                if(response.data.status == 'success'){
                    self.getToast().fire({
                        type: 'success',
                        title: response.data.message
                    });
                    this.isQuickBookConnected = false;
                    setTimeout(() => {
                        window.location.reload();
                    }, 1500);
                }else{
                    self.getToast().fire({
                        type: 'error',
                        title: response.data.message
                    });
                }
            });
        },
        formatSyncedDate(lastSync) {
            return moment.utc(lastSync).local().format("MM-DD-yyyy h:mm a");
        },
        syncInvoices(){
            let self = this;
            self.getToast().fire({
                type: 'success',
                title: 'Syncing invoices'
            });
            self.connectingQuickBook = true;
            let payload = {'company': self.company };
            axios.post(route('quick-book.sync-invoices'), payload).then(response => {
                if(response.data.status == 'success'){
                    self.getToast().fire({
                        type: 'success',
                        title: response.data.message
                    });
                    self.quickBookInvoiceObj = response.data.quickBookInvoices;
                    self.quickBookInvoiceData = JSON.parse(response.data.quickBookInvoices.quick_book_invoice_data);
                    self.isQuickBookConnected = true;
                }else{
                    self.getToast().fire({
                        type: 'error',
                        title: response.data.message
                    });
                }
                self.connectingQuickBook = false;
            });
        },
        goToCustomerOnQB(){
            let QBurl = process.env.MIX_QUICK_BOOK_ACCOUNT_BASE_URL;
            window.open(QBurl+"app/customerdetail?nameId="+this.connectedQBCustomer, "_blank");
        },
        selectOptionsForQuickBook(){
            $('#optionsForQuickBookModal').modal('show');
        },
        selectOptionsForQuickBookClose(){
            $('#optionsForQuickBookModal').modal('hide');
        },
        selectFromExistingQBCustomersModal(){
            this.selectedQuickBookCustomer = null;
            this.selectOptionsForQuickBookClose();
            $('#selectFromExistingQBCustomerModal').modal('show');
        },
        selectFromExistingQBCustomersModalClose(){
            this.selectedQuickBookCustomer = null;
            $('#selectFromExistingQBCustomerModal').modal('hide');
            this.selectOptionsForQuickBook();
        },
        selectQBCustomer(){
            if(!this.selectedQuickBookCustomer){
                this.getToast().fire({
                    type: 'error',
                    title: 'Please select a customer from drop down'
                });
                return false;
            }else{
                let payload = {'QBCustomer': this.selectedQuickBookCustomer, 'company': this.company };
                axios.post(route('quick-book.select-quick-book-customer'), payload).then(response => {
                    if(response.data.status == 'success'){
                        $('#selectFromExistingQBCustomerModal').modal('hide');
                        this.selectedQuickBookCustomer = null;
                        this.getToast().fire({
                            type: 'success',
                            title: response.data.message
                        });
                        this.fetchInvoices();
                    }else{
                        this.getToast().fire({
                            type: 'error',
                            title: response.data.message
                        });
                    }
                });
            }
        },
        selectCompanyContactForQBModal(){

            if(this.contacts.length == 0){
                this.getToast().fire({
                    type: 'error',
                    title: 'No contacts added to this company'
                });

                return false;
            }
            this.selectedCompanyContactForQB = null;
            this.selectOptionsForQuickBookClose();
            $('#selectCompanyContactForQBModal').modal('show');
        },
        selectCompanyContactForQBModalClose(){
            this.selectedCompanyContactForQB = null;
            $('#selectCompanyContactForQBModal').modal('hide');
            this.selectOptionsForQuickBook();
        },
        createCustomerToQB(){
            if(!this.selectedCompanyContactForQB){
                this.getToast().fire({
                    type: 'error',
                    title: 'Select a contact first'
                });

                return false;
            }else{
                let payload = {'contact': this.selectedCompanyContactForQB, 'company': this.company };
                axios.post(route('quick-book.create-quick-book-customer'), payload).then(response => {
                    if(response.data.status == 'success'){
                        $('#selectCompanyContactForQBModal').modal('hide');
                        this.selectedCompanyContactForQB = null;
                        this.getToast().fire({
                            type: 'success',
                            title: response.data.message
                        });
                        this.fetchInvoices();
                    }else{
                        this.getToast().fire({
                            type: 'error',
                            title: response.data.message
                        });
                    }
                });
            }
        },
        showDeleteContactModal(contact) {
            this.deleteableContact = contact;
            $("#deleteContactModal").modal("show");
        },
        hideDeleteContactModal() {
            this.deleteableContact = null;
            $("#deleteContactModal").modal("hide");
        },
        removeAssociatedContact() {
            let self = this;
            if(self.deleteableContact && self.deleteableContact.id) {
                axios.post(route('api.contact.remove-associated'), {contactId: self.deleteableContact.id, companyId: self.company.id}).then((response) => {
                    self.getToast().fire({
                        type: 'success',
                        title: 'Associated contact removed successfully.'
                    })
                    self.hideDeleteContactModal();
                    self.fetchContacts();
                }).catch((error) => {
                    //
                });
            }
        },
        debounceFilter(event) {
            clearTimeout(this.filter.timeout);
            const inputValue = event.target.value;
            if (inputValue.length > 2) {
                this.filter.timeout = setTimeout(() => {
                    if(event.target.value === ''){
                        this.isLoadingContacts = false;
                    }else{
                        this.isLoadingContacts = true;
                        this.fetchCompanies(event.target.value);
                    }
                }, 700, this);
            }
        },
        fetchCompanies(filter) {
            let self = this;
            self.filter.company_name = filter;
            axios.post(route('api.contact.searched.results'), {filter: self.filter.company_name}).then(({data}) => {
                self.searchedCompanyContacts = data.data;
                self.isLoadingContacts = false;
            }).catch(error => {
                self.isLoadingContacts = false;
            });
        },
        removeSelectedCompany(company) {
            this.$nextTick(() => {
                _.forEach(this.searchSelectedCompanyContacts, function(company) {
                    $('#company-selected-' + company.id).prop('checked', true);
                });
            });
        },
        addAssociatedCompanyContact() {
            let self = this;
            let searchSelectedCompanyContactIds = _.map(self.searchSelectedCompanyContacts, 'id');
            let payload = {company: self.company, contacts: JSON.stringify(searchSelectedCompanyContactIds)};
            axios.post(route('api.contact.company-association.add-associating-contacts'), payload).then((response) => {
                self.filter.company_name = '';
                self.filter.timeout = null;
                self.addCompanyContactAssociationStatus = false;
                self.fetchContacts();
                self.searchedCompanyContacts = [];
                self.searchSelectedCompanyContacts = [];
            }).catch(function(error) {
                //
            });
        },
        isCompanySelectionDisabled(company) {
            let exists = _.find(this.contacts, function(com) { return com.id == company.id });
            return (exists !== null && exists !== undefined);
        },
        showTabs() {
            this.addCompanyContactAssociationStatus = true;
            $('#add-existing-tab___BV_tab_button__').trigger('click');
        },
        contactCreated() {
            this.fetchContacts();
        },
        spectrumCustomerCodeChanged(data){
            this.$refs.CompanySpectrumComponent.pushOrUpdateCustomerToSpectrum(data.customerCode);
        },
        isERPSyncSettingActionUpdate() {
            let self = this;
            const settingIndex = _.findIndex(self.vistaConnectionData.erpSyncSettings, { 'entity_action': 'sync', 'entity_action_type': 'automatic', 'entity_action_depends_on': 'update' });

            return settingIndex !== -1;
        },
        isCompanyERPSynced() {
            if(this.vistaAccess && this.company.vista_customer_id && this.vistaConnectionData.vistaCompanyMapping && this.vistaConnectionData.vistaCompanyMapping.direction !== 'one-way-followup') {
                return true;
            }
            if(this.agaveErp.third_party_name === 'spectrum' && this.company.spectrum_customer_id
                && this.spectrumCompanyMapping && this.spectrumCompanyMapping.direction !== 'one-way-followup') {
                return true;
            }
            if(this.agaveErp.third_party_name === 'foundationNew' && this.company.foundation_customer_id
                && this.foundationCompanyMapping && this.foundationCompanyMapping.direction !== 'one-way-followup') {
                return true;
            }
            if(this.agaveErp.third_party_name === 'sage-300-cre' && this.company.sage_cre_customer_no
                && this.agaveErp.company_field && this.agaveErp.company_field.direction !== 'one-way-followup') {
                return true;
            }
            if(this.agaveErp.third_party_name === 'sage-100-contractor' && this.company.sage_customer_id
                && this.sageCompanyMapping && this.sageCompanyMapping.direction !== 'one-way-followup') {
                return true;
            }
        },
        syncCompanyToEnabledERP() {
            if(this.vistaAccess && this.company.vista_customer_id) {
                if(this.vistaConnectionData.checkContactMappedField && this.companyContactVistaHistory) {
                    this.pushOtherContactToVista();
                }
                else {
                    this.$refs.CompanyVistaComponent.connectOrUpdateVistaCompany();
                }
            }
            if(this.agaveErp.third_party_name === 'spectrum' && this.company.spectrum_customer_id) {
                this.$refs.CompanySpectrumComponent.connectCustomerToSpectrum();
            }
            if(this.agaveErp.third_party_name === 'foundationNew' && this.company.foundation_customer_id) {
                this.$refs.FoundationCompany.connectCustomerToFoundation();
            }
            if(this.agaveErp.third_party_name === 'sage-300-cre' && this.company.sage_cre_customer_no) {
                this.$refs.Sage300Company.showUpdateCustomerAgaveForm();
            }
            if(this.agaveErp.third_party_name === 'sage-100-contractor' && this.company.sage_customer_id) {
                this.$refs.Sage100Company.showUpdateCustomerAgaveForm();
            }
        },
    }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.recent-files{
    max-height: 500px;
    margin-bottom: 2rem;
    overflow: auto;
}
.tab-btn {
    padding: 6px 10px;
    /*background: #14b1af;*/
    cursor: pointer;
    margin-bottom: 1rem;
    outline: none;
    color: #3d4852;
    height: 41px;
    width: 150px;
}

.contactTabs {
    /*background: #14b1af;*/
    height: 41px
}

.activeTab {
    border-bottom: 3px solid green;
}

.tab {
    padding: 10px;
}
.circle{
    height: 100px;
    width: 100px;
    margin: 0 auto;
    margin-bottom: 10px;
    border-radius: 50%;
}
.circle_contact_image{
    height: 30px;
    width: 30px;
    display: inline-block;
    margin: auto;
    margin-bottom: 10px;
    border-radius: 50%;
}
.inactive-background{
    background:  #bfbfbf;
}
.background-none{
    background: none;
}
img.qb-small-logo {
    width: 27px;
    height: auto;
}

.model_loader{
    position: absolute;
    top: 0;
    left: 0;
    z-index: 100;
    width: 100%;
    height: 100%;
    display: none;
    background: rgb(0 0 0 / 57%);
}
.model_loader .model_spinner{
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.swal2-icon.swal2-warning.swal2-animate-warning-icon {
    color: red !important;
    border-color: red !important;
}
</style>
<style scoped>
select#teamSelect {
    font-size: 12px !important;
    color: #01b1af !important;
}
i.trash-icon-team:hover{
    color: red;
}
.text-green-foundation {
    color: #3eb784;
    font-size: 13px;
}
.hiddenRow {
    padding: 0 !important;
}
.no-btn-properties {
    background: none;
    color: #01B1AF;
    border: none;
    box-shadow: none;
}
.modal-title {
    font-weight: 600;
}
.confirm-checkbox {
    transform: scale(1.3) !important;
}
.company-contact-select-checkbox .custom-control {
    margin-top: unset !important;
    margin-right: unset !important;
}

.border-radius-25{
    border-radius: 0.25rem;
}
</style>
